import React from 'react';
import { MessageCircle } from 'lucide-react';
import { getDefaultInquiryURL } from '../../utils/whatsappGenerator';

const WhatsAppButton = () => {
  return (
    <a
      href={getDefaultInquiryURL()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#F5BCB1] hover:bg-[#efaaa0] text-stone-900 px-4 py-3 rounded-full shadow-lg shadow-[#F5BCB1]/25 hover:shadow-xl transition-all duration-300 group"
      aria-label="Order on WhatsApp"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm font-medium">Order on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
